<form [formGroup]="form">
  <div fxLayout="row">
    <div fxFlex="25">
  
      <!-- Ratio -->
      <mat-label>{{ 'ratio' | translate }} {{ 'bvo' | translate: 'upperCase' }} / {{ 'fno' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput 
          type="number" 
          formControlName="ratio" 
          placeholder="{{ 'ratio' | translate }}" 
          (keydown.enter)="$event.target.blur()">
        <span matSuffix>/ 1</span>
      </mat-form-field>

    </div>
    <div fxFlex="25">

      <!-- FNO -->
      <mat-label>{{ 'building' | translate }} {{ 'fno' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput type="number" formControlName="fno" placeholder="{{ 'fno' | translate: 'upperCase' }}">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>
    <div fxFlex="25">
  
      <!-- BVO -->
      <mat-label>{{ 'building' | translate }} {{ 'bvo' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput type="number" placeholder="{{ 'bvo' | translate: 'upperCase' }}" formControlName="bvo" (keydown.enter)="$event.target.blur()">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>
    <div fxFlex="25">
  
      <!-- BUI -->
      <mat-label>{{ 'building' | translate }} {{ 'bui' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput type="number" placeholder="{{ 'bui' | translate: 'upperCase' }}" formControlName="bui">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>  
  </div>
</form>
